import { forwardRef, useImperativeHandle, useRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

import { pickProps } from '../../utils/index.js';
import { Field, FieldElement, FieldProps, FieldPropsList } from '../Field/index.js';
import { InputText, InputTextProps, InputTextPropsList } from '../InputText/InputText.js';

export type TextFieldElement = FieldElement;
export interface TextFieldProps
  extends Omit<OverrideProps<FieldProps, InputTextProps>, 'children'> {
  label: string;
  inputRef?: React.Ref<HTMLInputElement>;
  value?: string;
}

export const TextField = styled(
  forwardRef<TextFieldElement, TextFieldProps>(
    ({ inputRef: inputRefProp, label, ...restProps }, ref) => {
      const inputRef = useRef<HTMLInputElement>(null);

      useImperativeHandle(inputRefProp, () => inputRef.current!, []);

      const [inputProps] = pickProps<InputTextProps>(restProps, InputTextPropsList);
      const [fieldProps] = pickProps<FieldProps>(
        restProps,
        FieldPropsList.filter((p) => !InputTextPropsList.includes(p as any))
      );

      return (
        <Field ref={ref} {...fieldProps}>
          <Field.Label>{label}</Field.Label>
          <InputText ref={inputRef} {...inputProps} />
          <Field.HelperText />
        </Field>
      );
    }
  )
).withConfig({
  displayName: 'TextField',
})``;
